export default {
	'set-home-location': 'تعيين موقع منزل',
	'generate-qr-all': 'توليد QR لكل الأسطر',
	'qr-code': 'QR كود',

	'add-passenger': 'إضافة راكب',
	'edit-passenger': 'تعديل راكب'
}